var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-form',{staticClass:"crud form help-padding",attrs:{"form":_vm.form,"store":_vm.store,"id":_vm.id,"edit":_vm.edit,"entity":_vm.entity,"title":_vm.title,"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }